import { useCallback } from "react";

import {
  copyGifLink,
  getGifFixedEmbedCode,
  getGifResponsiveEmbedCode,
  sendGifToTwitter,
  sendGifToReddit,
} from "utils/share";

import { IGif } from "services/types";
import { ShareMenu } from "./ShareMenu";

interface IShareGifMenuProps {
  gif: IGif;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  fullscreen?: boolean;
}

export const ShareGifMenu = (props: IShareGifMenuProps) => {
  const { gif, anchorEl, onClose, fullscreen = false } = props;

  const handleClick = useCallback(async (label: string) => {
    if (label === "Copy Link" || label === "Discord") {
      await copyGifLink(gif.id);
    } else if (label === "Reddit") {
      sendGifToReddit(gif);
    } else if (label === "Twitter") {
      sendGifToTwitter(gif.id);
    }

    onClose();
  }, [gif, onClose]);

  return (
    <ShareMenu
      anchorEl={anchorEl}
      onClick={handleClick}
      onClose={onClose}
      fixedEmbedCode={getGifFixedEmbedCode(gif)}
      responsiveEmbedCode={getGifResponsiveEmbedCode(gif)}
      fullscreen={fullscreen}
    />
  );
};
